import type { RoutingStatusResponse } from '@lousada/shared';
import { numericDate } from './time/calendar.js';

export function freshnessLine(status: RoutingStatusResponse | null): string | null {
  const timetable = status?.timetable ?? null;
  if (timetable === null) return null;
  if (timetable.publishedOn !== null)
    return `Dados de horários atualizados em ${numericDate(timetable.publishedOn)}`;
  if (timetable.acquiredAt !== null) {
    return `Dados de horários obtidos em ${numericDate(timetable.acquiredAt.slice(0, 10))}`;
  }
  return null;
}

export function validityLine(status: RoutingStatusResponse | null): string | null {
  const end = status?.dataHorizon?.end;
  if (end === undefined) return null;
  const last = new Date(Date.parse(end) - 1000).toISOString().slice(0, 10);
  return `válidos até ${numericDate(last)}`;
}
